function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { useAuthState, authUtil } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { forumInterfaceFunctions } from '../hooks/forumInterfaceFunctions';
import { useCategoriesState } from '../../context/categories';
import ForumPresentation from '../Forum/ForumPresentation';
import ContentItemCommentsPresentation from '../Forum/ContentItemCommentsPresentation';
import PostPresentation from '../Forum/PostPresentation';
import { LOG } from '../Constants';
import { useLog } from '../hooks/useLog';
const Forum = props => {
  // props
  const envVars = props.envVars;
  const forumKey = props.forumKey;
  const platformUser = props.user;
  const platformUserKey = platformUser === null || platformUser === void 0 ? void 0 : platformUser.discourseKey;
  const isGuidelineModalOpen = props.isGuidelineModalOpen;
  const setIsGuidelineModalOpen = props.setIsGuidelineModalOpen;
  const toggleProfileModal = props.toggleProfileModal;
  const dispatchForumAuth = props.dispatchForumAuth;

  // context
  const categoriesState = useCategoriesState();
  const authState = useAuthState();
  const envState = useEnvState();

  // state var bools
  const [showSpinner, setShowSpinner] = useState(true);
  const [showLoginScreen, setShowLoginScreen] = useState(false);
  const [tokenRefreshed, setTokenRefreshed] = useState(false);
  const [envInitialized, setEnvInitialized] = useState(false);
  const [authInitialized, setAuthInitialized] = useState(false);
  const [categoriesInitialized, setCategoriesInitialized] = useState(false);

  // state setter routines to pass to hook
  const setters = {
    setShowLoginScreen: setShowLoginScreen,
    setShowSpinner: setShowSpinner,
    setTokenRefreshed: setTokenRefreshed
  };

  // get hook objects
  const {
    setEnvironmentVars,
    setCategories,
    authenticateUser,
    authPlatformUser
  } = forumInterfaceFunctions(props, setters);

  // control logging
  const {
    log
  } = useLog();

  /**
   * manage env and auth cyle
   */

  // effect: set environment vars
  useEffect(() => {
    setEnvironmentVars(envVars);
  }, []);

  // effect: authenticate user once env state set
  useEffect(() => {
    var _envState$base_url;
    if (envState !== null && envState !== void 0 && (_envState$base_url = envState.base_url) !== null && _envState$base_url !== void 0 && _envState$base_url.length && !envInitialized) {
      log(`${LOG.check} 1. required envState ready`);
      setEnvInitialized(true);
      authenticateUser();
    }
  }, [envState]);

  // effect: authenticate user on token refresh
  useEffect(() => {
    if (tokenRefreshed === true) {
      setTokenRefreshed(false);
      authPlatformUser();
    }
  }, [platformUserKey, tokenRefreshed]);

  // effect: set user authenticated bool
  useEffect(() => {
    if (authUtil.userAuthed(authState) && !authInitialized) {
      log(`${LOG.check} 2. required authState ready`, authState);
      setAuthInitialized(true);
    }
  }, [authState]);
  useEffect(() => {
    var _envState$base_url2;
    if (!categoriesState.forumCategories.length && !categoriesInitialized && envState !== null && envState !== void 0 && (_envState$base_url2 = envState.base_url) !== null && _envState$base_url2 !== void 0 && _envState$base_url2.length) {
      log(`${LOG.check} 2b. update categories context`);
      setCategoriesInitialized(true);
      setCategories(props.forumType); // this calls an async routine that updates the categories context
    }
  }, [authInitialized]);
  return props.forumType === 'Forum' ? /*#__PURE__*/React.createElement(ForumPresentation, _extends({}, props, {
    showSpinner: showSpinner,
    showLoginScreen: showLoginScreen,
    forumKey: forumKey,
    userAuthenticated: authInitialized,
    isGuidelineModalOpen: isGuidelineModalOpen,
    setIsGuidelineModalOpen: setIsGuidelineModalOpen,
    toggleProfileModal: toggleProfileModal,
    dispatchForumAuth: dispatchForumAuth
  })) : props.forumType === 'ContentItem' ? /*#__PURE__*/React.createElement(ContentItemCommentsPresentation, _extends({}, props, {
    showSpinner: showSpinner,
    showLoginScreen: showLoginScreen,
    userAuthenticated: authInitialized,
    toggleProfileModal: toggleProfileModal,
    dispatchForumAuth: dispatchForumAuth
  })) : /*#__PURE__*/React.createElement(PostPresentation, _extends({}, props, {
    showSpinner: showSpinner,
    showLoginScreen: showLoginScreen,
    userAuthenticated: authInitialized,
    id: "newTopic",
    key: "newTopic"
  }));
};
export default Forum;
//# sourceMappingURL=Forum.js.map